export default __webpack_public_path__ + "static/media/LandingPad.256.633c4848.png";